export default function templateReducer(state = {
    templates: [],
    fetching: false,
    fetched: false,
    errors: {}
  }, action) {
    switch (action.type) {
      case 'GET_TEMPLATES_PENDING': {
        return {...state, fetching: true, fetched: false}
      }
      case 'GET_TEMPLATES_FULFILLED': {
        return {
          ...state,
          fetching: false,
          fetched: true,
          templates: action.payLoad,
        }
      }
      case 'GET_TEMPLATES_REJECTED': {
        return {...state, errors: action.payLoad}
      }
      default:
    }
  
    return {...state};
  }
  


// WEBPACK FOOTER //
// ./src/reducers/templateReducer.js